import React, { useContext } from 'react';
import { FastField } from 'formik';
import { SttInput, SttTranslateHook } from '@stt-componentes/core';
import { FUNCIONARIO_ENVIO } from '../fieldNames';

const ResponsavelEnvio = () => {
    const { strings } = useContext(SttTranslateHook.I18nContext);

    return (
        <FastField name={FUNCIONARIO_ENVIO}>
            {({
                field
            }) => (
                <SttInput
                    {...field}
                    label={strings.responsavelEnvio}
                />
            )}
        </FastField>
    );
};

export default ResponsavelEnvio;